module.exports = __webpack_public_path__ + "img/SketchPng718796f380d6ce02541da6d48f62419f747e0a617f17b8260967d7f20606b956.55ea8e5d.png";